import { Button } from '@talentmesh/ui/components/button';
import { TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import { generatePath, useNavigate } from 'react-router';
import RecruitmentMenuButton from '../RecruitmentMenuButton';
import AiSparklesIcon from '@/Components/TalentMeshIcons/AiSparklesIcon';
import useCompanyId from '@/Hooks/UseCompanyId';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import { RecruitmentOverview } from '@/Models/RecruitmentOverview';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

export interface RecruitmentListItemHeaderProps {
    recruitment: RecruitmentOverview;
}

export const RecruitmentListItemHeader = ({ recruitment }: RecruitmentListItemHeaderProps) => {
    const { name, status, id, jobLocation, workArrangement, jobAdId } = recruitment;
    const companyId = useCompanyId();
    const navigate = useNavigate();
    const disabled = status === AssessmentStatuses.Closed;

    return (
        <div className="flex flex-row items-start gap-2">
            <div className="flex min-w-0 flex-1 flex-col gap-1">
                <TypographyH3 className="text-foreground">{name}</TypographyH3>
                {(jobLocation || workArrangement === 'Remote') && (
                    <TypographyP className="text-muted-foreground">
                        {workArrangement === 'Remote' ? UIStrings.FullyRemote : jobLocation}
                    </TypographyP>
                )}
            </div>
            <div className="flex shrink-0 flex-row items-center justify-end gap-2">
                <Button
                    disabled={disabled}
                    variant={disabled ? 'outline' : 'default'}
                    data-cy="manageButton"
                    size="sm"
                    className="min-w-24"
                    onClick={() => navigate(generatePath(RoutePath.AgenticAiSearch, { assessmentId: id, companyId }))}
                >
                    <AiSparklesIcon />
                    {UIStrings.Source}
                </Button>
                <RecruitmentMenuButton id={id} name={name} status={status} jobAdId={jobAdId} />
            </div>
        </div>
    );
};
